<template>
  <CategoryTop :breadcrumbs-parent-routes="['onlineTrainingCategory']"
    :title="$t(`trainings.online.categories.${route.params.id}.subtitle`)"
    :description="$t(`trainings.online.categories.${route.params.id}.subdesription`)" v-if="extendedOnlineTrainigs()" />
</template>

<script setup>
import CategoryTop from "@/components/General/CategoryTop/index.vue";
import { useRoute } from "vue-router";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { showExtendedOnlineTrainings } from "@/composables/useProfileFieldCheck";


const { tenantConfig } = useTenantConfig();
const { extendedOnlineTrainigs } = showExtendedOnlineTrainings(tenantConfig);

const route = useRoute();

</script>
